export default __webpack_public_path__ + "static/media/discord-i.aacf5225.svg";